import { connect } from 'react-redux'
import QuestionNavButtons from './QuestionNavButtons'
import {nextQuestion, prevQuestion} from "../../../../actions/exam";

const mapStateToProps = (state, ownProps) => {
  const currentQuestion = state.exam.currentQuestion + 1;
  const nbQuestions = state.exam.questions.length;
  return {
    hasNext: currentQuestion < nbQuestions,
    hasPrev: currentQuestion > 1
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    nextQuestion: () => {
      dispatch(nextQuestion());
    },
    prevQuestion: () => {
      dispatch(prevQuestion());
    },
  };
};

const QuestionNavContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionNavButtons);

export default QuestionNavContainer
